import { render, staticRenderFns } from "./AddTransactionType.vue?vue&type=template&id=13dd2944&"
import script from "./AddTransactionType.vue?vue&type=script&lang=js&"
export * from "./AddTransactionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports